/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { InitDialogViewService } from '@gh/common-shared';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { Observable } from 'rxjs';

export interface LogDialogConfig {
  content: string | Observable<string>;
}

@Injectable()
export class LogDialogPreloadService implements InitDialogViewService<LogDialogConfig> {
  initDialogView(route: DialogRouteSnapshot<LogDialogConfig>): any {
    return route.input.content;
  }
}
